import { CommonConfigsResponse } from "../models/Response/commonConfigResponse";
import { MasterLanguageDropdownData } from "../models/Response/masterLanguageDropdownResponse";
import { MasterSettingsListResponseData } from "../models/Response/masterSettingsListResponse";
import { UnifiedResponse } from "../models/Response/unifiedResponse";
import apiClient from "./apiClient";

export const commonApi = {
    fetchCommonConfig: async (): Promise<UnifiedResponse<CommonConfigsResponse>> => {
        const response = await apiClient.get<UnifiedResponse<CommonConfigsResponse>>(
            "/general/getcommonconfigs"
        );
        return response.data;
    },

    fetrieveMasterSettingsRegisterWhatsappDetailAsync: async (): Promise<UnifiedResponse<MasterSettingsListResponseData>> => {
        const response = await apiClient.get<UnifiedResponse<MasterSettingsListResponseData>>(
            "/settings/master_settings/register-whatsapp-detail"
        );
        return response.data;
    },

    fetchMasterLanguageDropdown: async (): Promise<UnifiedResponse<MasterLanguageDropdownData>> => {
        const response = await apiClient.get<UnifiedResponse<MasterLanguageDropdownData>>(
            "/settings/master_language/dropdown"
        );
        return response.data;
    }
};